export const DEFAULT_BUSINESS_CASE_OFFER_SENT_NO_RESPONSE_MINIMUM_DAYS = 2;
